import React from "react";

/** PersonaChips — displays "Best for" audience chips on room detail pages. */
export function PersonaChips({ items = [], className = "" }) {
  if (!items?.length) return null;
  return (
    <ul
      className={`flex flex-wrap gap-2 ${className}`}
      data-testid="persona-chips"
    >
      {items.map((item) => (
        <li
          key={item}
          className="inline-flex items-center px-3 py-1 rounded-full border border-brass/50 bg-brass/10 text-brass text-xs uppercase tracking-[0.14em] font-medium"
        >
          {item}
        </li>
      ))}
    </ul>
  );
}
